import { inject } from '@angular/core';
import { RedirectFunction } from '@angular/router';
import { ConversationView } from '@shared/modules/conversations/common/constants/conversation-view';
import { CONVERSATION_VIEW_ROUTE } from '@shared/modules/conversations/common/constants/conversation-view-route';
import { LogLevel } from '@shared/modules/logs/common/constants/log-level';
import { LoggerService } from '@shared/modules/logs/services/logger.service';

export const DEFAULT_VIEW_URL = `/${CONVERSATION_VIEW_ROUTE}/${ConversationView.loopInbox}`;

/**
 * Target of the catch-all route. A plain `redirectTo` string would do the redirecting, but it would
 * also silence the unmatched URLs we used to see as NG04002 in the client logs — and those are the
 * only signal we get about links out there that no longer resolve. A redirect function runs in an
 * injection context, so it can keep reporting them on the way to the default view.
 */
export const redirectUnmatchedRoute: RedirectFunction = ({ url }): string => {
  inject(LoggerService).log({
    message: `Unmatched route, redirecting to the default view: /${url.map(segment => segment.path).join('/')}`,
    level: LogLevel.WARN
  });

  return DEFAULT_VIEW_URL;
};
